import { portalAPI } from './portalAPI';

export const APISmailySlice = portalAPI.enhanceEndpoints({ addTagTypes: ['Smaily'] }).injectEndpoints({
    endpoints: (builder) => ({
        isSmailyIntegrationEnabled: builder.query<boolean, void>({
            query: () => '/v1/integrations/smaily/enabled',
            keepUnusedDataFor: 10 * 60,
        }),
    }),
    overrideExisting: false,
});

export const { useIsSmailyIntegrationEnabledQuery } = APISmailySlice;
